// Options mirror the real drop worker form (drop/worker.js) verbatim — same
// submit values, same "+$X" hints. Do not invent options.

export interface RollType {
  key: "color35" | "color120" | "bw35" | "bw120";
  label: string;
  sub: string;
  countName: string;
  notesName: string;
}

export const ROLL_TYPES: RollType[] = [
  { key: "color35", label: "35mm color", sub: "C-41", countName: "color35_count", notesName: "color35_notes" },
  { key: "color120", label: "120 color", sub: "C-41", countName: "color120_count", notesName: "color120_notes" },
  { key: "bw35", label: "35mm B&W", sub: "black & white", countName: "bw35_count", notesName: "bw35_notes" },
  { key: "bw120", label: "120 B&W", sub: "black & white", countName: "bw120_count", notesName: "bw120_notes" },
];

export const SCAN_SIZES = [
  { value: "high_res", label: "High Res", hint: "Recommended" },
  { value: "max_res", label: "Max Res", hint: "+$3 / roll" },
  { value: "small", label: "Small", hint: "" },
  { value: "none", label: "No digitals — develop only", hint: "" },
];

export const FILE_FORMATS = [
  { value: "jpg", label: "JPG", hint: "Most common" },
  { value: "tiff", label: "TIFF", hint: "+$2 / roll" },
];

export const SCAN_DELIVERY = [
  { value: "email", label: "A zip file via email is fine", hint: "" },
  { value: "gallery", label: "Online gallery", hint: "+$6 / roll" },
];

export const PRINTS = [
  { value: "none", label: "No thanks!" },
  { value: "all", label: "Yes, for all my rolls" },
  { value: "some", label: "Yes — I'll note which rolls below" },
];

export const NEGATIVES = [
  { value: "dispose", label: "Safely dispose of them", hint: "" },
  { value: "pickup", label: "I'll schedule a time to pick them up", hint: "" },
  { value: "return", label: "Mail them back cut & sleeved", hint: "+$6 / order" },
];

export const PICKUP_FORMAT = [
  { value: "cut", label: "Cut & sleeved (35mm only)" },
  { value: "uncut", label: "Uncut" },
];

export const PUSH_STOPS = [
  { value: "-2", label: "−2" },
  { value: "-1", label: "−1" },
  { value: "1", label: "+1" },
  { value: "2", label: "+2" },
];
